import {useState, useEffect} from "react";
import { Grid, IconButton, Stack, Typography } from "@mui/material";
import {EditRounded, FileUpload, HighlightOff} from "@mui/icons-material";
import { useForm, FormProvider } from "react-hook-form";
import {useTranslation} from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRecoilValue } from "recoil";
import { DMS_DOCUMENTS_FORM_VALIDATION_SCHEMA } from "../../../../search-dms/config";
import {NetworkScope} from "../../../../types";
import {useHasScope} from "../../../../../../config/globalConfig";
import DocumentGrid from "./DocumentGrid";
import UploadFileWrapper from "./UploadFileWrapper";
import { documentsRsState } from "../../../../search-repair-shop/state";

const DocumentRepositoryRs = () => {
    const {t} = useTranslation(['network', 'translation']);
    const hasScope = useHasScope;
    
    const documentRs = useRecoilValue(documentsRsState);

    const [isDisabled, setIsDisabled] = useState(true);
    const [openAddDocument, setOpenAddDocument] = useState<boolean>(false);

    const handleDisableForm = (value:boolean) => {
        setIsDisabled(value);
    }

    const documentsForm = useForm({
        defaultValues: { documents: documentRs ?? [] },
        resolver: yupResolver(
            DMS_DOCUMENTS_FORM_VALIDATION_SCHEMA
        )
    });

    useEffect(() => {
        documentsForm.setValue("documents",documentRs);
    },[documentRs])

    return (
        <FormProvider {...documentsForm}>
            <Typography variant="h6">
                {t("rsDetail.documentRepositoryDms.accordion.title")}
            </Typography>
            <Grid item xs={12}>
                <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                    {hasScope(NetworkScope.MsMng) && isDisabled &&
                        <IconButton color="accent" onClick={() => {handleDisableForm(false)}}>
                            <EditRounded/>
                        </IconButton>
                    }
                    {hasScope(NetworkScope.MsMng) && !isDisabled &&
                        <>
                            <IconButton color="accent" onClick={() => setOpenAddDocument(true)}>
                                <FileUpload />
                            </IconButton>
                            <IconButton color="accent" onClick={() => {handleDisableForm(true)}}>
                                <HighlightOff />
                            </IconButton>
                        </>
                    }
                </Stack>
            </Grid>
            <DocumentGrid list={documentRs} isDisabled={isDisabled}/>
            <UploadFileWrapper open={openAddDocument} setOpen={setOpenAddDocument} />
        </FormProvider>
    )
}

export default DocumentRepositoryRs;
